module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_1.bcde55d5.png";